import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { IhmUnifiedStartEndDatePickerComponent } from './ihm-unified-start-end-date-picker.component';

export const DATEPICKER_FORMATS = {
  parse: {
    dateInput: 'M/D/YY'
  },
  display: {
    dateInput: 'M/D/YY',
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'YYYY'
  }
};

@NgModule({
  declarations: [IhmUnifiedStartEndDatePickerComponent],
  imports: [
    CommonModule,
    MatDatepickerModule,
    MatIconModule,
    MatMenuModule,
    MatButtonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule
  ],
  providers: [{ provide: MAT_DATE_FORMATS, useValue: DATEPICKER_FORMATS }],
  exports: [IhmUnifiedStartEndDatePickerComponent]
})
export class IhmUnifiedStartEndDatePickerModule {}
